const o = {
  code: "ko",
  facebook: "ko_KR",
  label: "한국어",
  loadingText: "로딩 중...",
  translations: {
    ar: "아랍어",
    de: "독일어",
    en: "영어",
    es: "스페인어",
    fr: "프랑스어",
    he: "히브리어",
    hi: "힌디어",
    id: "인도네시아어",
    it: "이탈리아어",
    ja: "일본어",
    km: "크메르어",
    ko: "한국어",
    lo: "라오어",
    ms: "말레이어",
    nl: "네덜란드어",
    pt: "포르투갈어",
    ru: "러시아어",
    th: "태국어",
    tl: "필리핀어",
    tr: "터키어",
    vi: "베트남어",
    "zh-CN": "중국어 (간체)",
    "zh-TW": "중국어 (번체)"
  }
};
export {
  o as korean
};
